import {metadaApi} from '@dms/api/base';

import {
  CorAllowDefaultBankTransferApiArg,
  CorAllowDefaultBankTransferApiResponse,
  CorDisallowDefaultBankTransferApiArg,
  CorDisallowDefaultBankTransferApiResponse,
  CorGetBankTransferSettingApiArg,
  CorGetBankTransferSettingApiResponse,
  CorUpdateBankTransferSettingApiArg,
  CorUpdateBankTransferSettingApiResponse,
} from './types';

export const metadaCheckoutApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getBankTransferSetting: build.query<
      CorGetBankTransferSettingApiResponse,
      CorGetBankTransferSettingApiArg
    >({
      query: () => ({
        url: `/core/v1/bank-transfer-setting`,
      }),
      providesTags: [{type: 'BankTransferSetting', id: 'DETAIL'}],
    }),
    updateBankTransferSetting: build.mutation<
      CorUpdateBankTransferSettingApiResponse,
      CorUpdateBankTransferSettingApiArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/bank-transfer-setting`,
        method: 'PUT',
        body: queryArg.body,
      }),
      invalidatesTags: [{type: 'BankTransferSetting', id: 'DETAIL'}],
    }),
    allowDefaultBankTransfer: build.mutation<
      CorAllowDefaultBankTransferApiResponse,
      CorAllowDefaultBankTransferApiArg
    >({
      query: () => ({
        url: `/core/v1/bank-transfer-setting/allow-default`,
        method: 'POST',
      }),
      invalidatesTags: [{type: 'BankTransferSetting', id: 'DETAIL'}],
    }),
    disallowDefaultBankTransfer: build.mutation<
      CorDisallowDefaultBankTransferApiResponse,
      CorDisallowDefaultBankTransferApiArg
    >({
      query: () => ({
        url: `/core/v1/bank-transfer-setting/disallow-default`,
        method: 'POST',
      }),
      invalidatesTags: [{type: 'BankTransferSetting', id: 'DETAIL'}],
    }),
  }),
});

export const {
  useGetBankTransferSettingQuery,
  useUpdateBankTransferSettingMutation,
  useAllowDefaultBankTransferMutation,
  useDisallowDefaultBankTransferMutation,
} = metadaCheckoutApi;
